<template lang="pug">
  section
    //- Sharer.sharer
    .jumbo
      .mask
        img(:src="img" :alt="title")
    .content.content-title
      header
        h2 {{title}}
          small(v-if="undertitle") {{undertitle}}
        h4.undertitle(v-if="downtitle") {{downtitle}}

</template>
<script>
export default {
  components: {

  },
  props: {
    title: String,
    undertitle: String,
    downtitle: String,
    img: String
  }
}
</script>
<style lang="scss" scoped>
  section{
    height: 80vh;
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid black;
    margin-bottom: 10vh;
    .mask{
      // margin-top: -15vh;
      // margin-bottom: 1rem;
      // width: 150%;
      // margin-left: -25%;
    }
    @media (max-width: 900px){
      height: 90vh;
      // .mask{
      //   width: 200%;
      //   margin-left: -50%;
      // }
    }
    @media (max-width: 600px){
      height: 90vh;
      // .mask{
      //   width: 250%;
      //   margin-left: -75%;
      // }
    }
    &:before{
      content: '';
      left: 0;
      right: 0;
      bottom: -3px;
      position: absolute;
      z-index: 2;
      height: 60vh;
      background: linear-gradient(transparent, black);
    }
    &:after{
      content: '';
      left: 0;
      right: 0;
      top: -3px;
      position: absolute;
      z-index: 2;
      height: 20vh;
      background: linear-gradient(rgba(0,0,0,0.8), transparent);
    }
    img{
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }
  }

  .block,
  header,
  .title{
    max-width: $maxwidth;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 800px){
      padding: 0 1rem;
      max-width: 100%;
    }
  }
  .title{
    margin-bottom: 2rem;
  }
  h2{
    @include fluid-type(360px,
  1440px,
  42px,
  96px);
    text-align: center;
    margin-bottom: 2rem;
    // text-shadow: 1px 1px 0px rgba(black, 0.9), 1px 2px 3px rgba(black, 0.2) ;
    color: white;
    font-family: 'LaTercera', sans-serif;
    text-transform: uppercase;
    letter-spacing: 1px;
    small{
      display: block;
      font-size: 3rem;
      line-height: 3rem;
    }
  }
  .content-title{
    position: absolute;
    z-index: 3;
    bottom: 0;
    left: 0;
    right: 0;
    padding-bottom: 3rem;
  }
  .undertitle{
    @include fluid-type(360px,
  1440px,
  18px,
  26px);
    line-height: 160%;
    // font-family: 'Open Sans', sans-serif;
    text-align: center;
    font-weight: 400;
  }
  h4{
    color: white;
  }


</style>

